import type { ComponentProps, ReactNode } from "react"

import { Link } from "@/3514/components/shared/link/link.component"

enum ECoachConferenceAccountVariant {
    Zoom = "zoom",
    MSTeams = "msTeams"
}

type TCoachConferenceAccount = {
    variant: ECoachConferenceAccountVariant
    linkUrl: string | null
    email: string
}

type TCoachConferenceAccountRenderConfig = {
    title: string
    description: string
    image: ReactNode
    actionProps: ComponentProps<typeof Link> | undefined
    status: string | undefined
}

export type { TCoachConferenceAccount, TCoachConferenceAccountRenderConfig }
export { ECoachConferenceAccountVariant }
